var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKycInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82296_32320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.500977 8.23798C0.500977 10.4205 1.15714 12.5634 2.70536 14.1489C4.21253 15.6925 6.32321 16.4783 8.46427 16.4783L11.8309 9.27474L8.46427 0.5C6.3262 0.5 4.30256 1.23617 2.77621 2.75844C1.32894 4.20184 0.500977 6.19361 0.500977 8.23798Z",
    fill: "#F5BA1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46289 0.5V16.4783H16.4996V8.23798C16.4996 6.12901 15.6137 4.0838 14.0842 2.63321C12.5454 1.17379 10.5617 0.5 8.46289 0.5Z",
    fill: "#F5BA1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65259 5.7544C9.19637 5.7544 9.63721 5.31357 9.63721 4.76978C9.63721 4.22598 9.19637 3.78516 8.65259 3.78516C8.1088 3.78516 7.66797 4.22598 7.66797 4.76978C7.66797 5.31357 8.1088 5.7544 8.65259 5.7544Z",
    fill: "#E15858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65742 13.1651C8.18156 13.1651 7.7959 12.7947 7.7959 12.3375V7.64792C7.7959 7.19079 8.18156 6.82031 8.65742 6.82031C9.13329 6.82031 9.51895 7.19079 9.51895 7.64792V12.3375C9.51895 12.7947 9.13329 13.1651 8.65742 13.1651Z",
    fill: "#E15858"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82296_32320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycInfo);
export default __webpack_public_path__ + "static/media/kycInfo.ed5b58a8fc0a033132a431fb989b9e77.svg";
export { ForwardRef as ReactComponent };